import { Component } from 'react';

class SectionCont4 extends Component {
	render() {
		return (
			<section id="" className="sub-content cont4">
				<div className="sub-inner">
					<div className="title-group">
						<strong className="title">왜 Stella인가? 연결된 ERP vs 단절된 ERP</strong>
						<p className="desc">
							타사 ERP가 영업·구매·재고·회계가 분절된 구조로 추가 작업과 오류를 발생시키는 반면,
							<br />
							Stella는 <b>전과정을 자동으로 연결</b>해 한 번의 흐름으로 경영 보고서까지 완성합니다.
						</p>
					</div>
					<div className="step-box">
						<div className="title type1">타사 ERP — 회계 중심, 단절된 구조</div>
						<div className="step-wrap">
							<ul className="step-list type1">
								<li>
									<div className="step-item ico1">
										<p>영업 시스템</p>
									</div>
									<p className="desc">엑셀 수동 관리</p>
								</li>
								<li>
									<div className="step-item ico2">
										<p>구매 시스템</p>
									</div>
									<p className="desc">엑셀 수동 관리</p>
								</li>
								<li>
									<div className="step-item ico3">
										<p>재고 시스템</p>
									</div>
									<p className="desc">엑셀 또는 별도 프로그램</p>
								</li>
								<li>
									<div className="step-item ico4">
										<p>회계 모듈 중심</p>
									</div>
									<p className="desc">수동 입력</p>
								</li>
							</ul>
						</div>
					</div>
					<div className="step-box">
						<div className="title type2">스텔라 ERP — 영업부터 경영보고서까지 자동 연결된 End-to End 통합 시스템</div>
						<div className="step-wrap">
							<ul className="step-list type2">
								<li>
									<div className="step-item ico5">
										<p>영업 관리</p>
										<ul>
											<li>견적·수주관리</li>
											<li>고객사 매출 추적</li>
											<li>영업 파이프라인</li>
										</ul>
									</div>
								</li>
								<li>
									<div className="step-item ico2">
										<p>구매 관리</p>
										<ul>
											<li>발주·입고·거래처 관리</li>
											<li>매입 비용 자동 집계</li>
											<li>B2B 수발주 연동</li>
										</ul>
									</div>
								</li>
								<li>
									<div className="step-item ico3">
										<p>재고 관리</p>
										<ul>
											<li>입출고 실시간 추적</li>
											<li>모바일 재고관리</li>
											<li>재고 자동 반영</li>
										</ul>
									</div>
								</li>
								<li>
									<div className="step-item ico4">
										<p>회계·결산</p>
										<ul>
											<li>자동 전표 생성</li>
											<li>실시간 손익확인</li>
											<li>월말 결산 자동화</li>
										</ul>
									</div>
								</li>
								<li>
									<div className="step-item ico6">
										<p>경영 보고서</p>
										<ul>
											<li>경영보고 대시보드</li>
											<li>실시간 KPI 확인</li>
											<li>경영진 즉시 보고</li>
										</ul>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</section>
		);
	}
}

export default SectionCont4;
